// MIME type to file extension mapping
const MIME_TO_EXTENSION: Record<string, string> = {
  // Images
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
  'image/tiff': 'tiff',

  // Documents
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',

  // Videos
  'video/mp4': 'mp4',
  'video/webm': 'webm',
  'video/ogg': 'ogg',

  // Archives
  'application/gzip': 'gz',
  'application/zip': 'zip',
  'application/x-rar-compressed': 'rar',
  'application/x-7z-compressed': '7z',
};

/**
 * Returns the file extension for a mimetype
 * @returns {string} The file extension without the dot
 */
export default function getExtensionFromMimeType(mime: string) {
  // Check if we have a direct mapping for this MIME type
  if (MIME_TO_EXTENSION[mime]) {
    return MIME_TO_EXTENSION[mime];
  }

  // Fallback: extract extension from MIME type
  return mime.replace(/^\w+\//, '');
}
